import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL_WEB = `${BaseUrl}categories-product-detail`; // Fake API URL

// const token = localStorage.getItem('token');

export const createCategoriesProductDetail = (product) => {
    const token = localStorage.getItem('token');

    return axios.post(API_URL_WEB, product, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const updateCategoriesProductDetail = (id, product) => {
    const token = localStorage.getItem('token');

    return axios.patch(`${API_URL_WEB}/${id}`, product, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const deleteCategoriesProductDetail = (id) => {
    const token = localStorage.getItem('token');

    return axios.delete(`${API_URL_WEB}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const findByidPaketDetil = (id) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}/find-by-id-paket-detil/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}